import { mapGetters } from 'vuex';

export default {
  name: 'AppRedirect',
  computed: {
    ...mapGetters('site', ['appstoreLink', 'googleplayLink']),
  },
  created() {
    if (this.appstoreLink.length > 0 && this.googleplayLink.length > 0) {
      const clickedAt = Date.now();
      if (navigator.userAgent.toLowerCase().indexOf('iphone') > -1) {
        setTimeout(() => {
          if (Date.now() - clickedAt < 2000) {
            window.location.href = this.appstoreLink;
          }
        }, 500);
      }
      if (navigator.userAgent.toLowerCase().indexOf('android') > -1) {
        window.location.href = this.googleplayLink;
      }
    }
  },
  render() {},
};
